import { Constants } from "../../data/constants";
import { HttpService } from "../../utils/HttpService";

export class AccountGroupService {
  constructor() {
    this.constants = new Constants();
    this.HttpService = new HttpService();
  }

  createGroupAccount = async (session_id, Account, cfg) => {
    try {
      return await this.HttpService.postJson(
        this.constants.groupServicesURLs.postGroup,
        {
          accountId: Account.accountId,
          groupName: Account.groupName,
          groupType: Account.groupType,
          cfg: cfg,
          isReadyFlow:Account.isReadyFlow,
          cfgOneStep:Account.cfgOneStep
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getGroups = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.groupServicesURLs.getGroups,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  deleteGroupAccount = async (session_id, groupId) => {
    try {
      return await this.HttpService.deleteJson(
        this.constants.groupServicesURLs.getGroups +
          `byAccountId` +
          `/groupId/${groupId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  getAccountGroups = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.groupServicesURLs.getGroups + `byAccountId`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getGroupByAccountIdAndGroupIdService = async (session_id, groupId) => {
    try {
      return await this.HttpService.getJson(
        this.constants.groupServicesURLs.getGroups +
          `byAccountId` +
          `/groupId/${groupId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  editGroupAccount = async (session_id, groupAccount, cfg) => {
    try {
      return await this.HttpService.putJson(
        this.constants.groupServicesURLs.editGroup,
        {
          groupId: groupAccount.groupId,
          groupStatus: groupAccount.groupStatus,
          accountId: groupAccount.accountId,
          groupName: groupAccount.groupName,
          groupType: groupAccount.groupType,
          cfg: cfg,
          isReadyFlow:groupAccount.isReadyFlow,
          cfgOneStep:groupAccount.cfgOneStep
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getCfgGroupId = async (session_id, groupId) => {
    try {
      return await this.HttpService.getJson(
        this.constants.cfgGroupServicesURLs.getCfgGroup +
          `byAccountId` +
          `/groupId/${groupId}`,

        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getAccountGroupsByType = async (session_id, type) => {
    try {
      return await this.HttpService.getJson(
        this.constants.groupServicesURLs.getGroupsByType + `/type/${type}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
}
